import { render } from "./PayrollDetailsTable.vue?vue&type=template&id=bcd2785e&ts=true"
import script from "./PayrollDetailsTable.ts?vue&type=script&lang=ts&external"
export * from "./PayrollDetailsTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__